import { createSlice } from "@reduxjs/toolkit";

// Initial authentication state
const initialState = {
  token: null,                // JWT or session token
  user: null,                 // user details (object)
  role: null,                 // user role (e.g., admin, user)
  profileImage: null,         // user profile image
  purchasedSubscription: null,// subscription plan user purchased
  chatEnabled: null,          // whether chat feature is enabled
  activeSubscription: null,   // current active subscription details
  onboardingCompleted: null,  // flag for onboarding completion
  is_blueprint_subscription: false, // whether subscription has document_file_url (blueprint/PDF)
  subscription_has_document: false, // whether subscription has document content
  is_renewal_subscription: false, // whether subscription is renewable
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // Set authentication details on login
    setAuth: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload.user;
      state.role = action.payload.role;
      state.profileImage = action.payload.profileImage || null;
      state.purchasedSubscription = action.payload.purchasedSubscription;
      state.chatEnabled = action.payload.chatEnabled;
      state.activeSubscription = action.payload.activeSubscription;
      state.onboardingCompleted = action.payload.onboardingCompleted;
      state.is_blueprint_subscription = action.payload.is_blueprint_subscription || false;
      state.subscription_has_document = action.payload.subscription_has_document || false;
      state.is_renewal_subscription = action.payload.is_renewal_subscription || false;
    },

    // Update subscription-related values
    updatePurchasedSubscription: (state, action) => {
      state.purchasedSubscription = action.payload.purchasedSubscription;
      state.chatEnabled = action.payload.chatEnabled;
      state.activeSubscription = action.payload.activeSubscription;
      
      // Update subscription_has_document if provided
      if (action.payload.subscription_has_document !== undefined) {
        state.subscription_has_document = action.payload.subscription_has_document;
      }
      
      // Update is_renewal_subscription if provided
      if (action.payload.is_renewal_subscription !== undefined) {
        state.is_renewal_subscription = Boolean(action.payload.is_renewal_subscription);
      }
      
      // Check if subscription has document_file_url to determine if it's a blueprint subscription
      if (action.payload.activeSubscription && 
          action.payload.activeSubscription.subscription_contents && 
          action.payload.activeSubscription.subscription_contents[0] && 
          action.payload.activeSubscription.subscription_contents[0].document_file) {
        state.is_blueprint_subscription = true;
      } else {
        state.is_blueprint_subscription = false;
      }
    },

    // Update onboarding completion flag
    updateOnboardingCompleted: (state, action) => {
      state.onboardingCompleted = action.payload.onboardingCompleted;
    },

    // Update blueprint subscription flag based on document_file_url
    updateBlueprintSubscription: (state, action) => {
      state.is_blueprint_subscription = action.payload.is_blueprint_subscription;
    },

    // Clear all auth data (on logout)
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.role = null;
      state.profileImage = null;
      state.purchasedSubscription = null;
      state.chatEnabled = null;
      state.activeSubscription = null;
      state.onboardingCompleted = null;
      state.is_blueprint_subscription = false;
      state.subscription_has_document = false;
      state.is_renewal_subscription = false;
    },
  },
});

// Export actions and reducer
export const { setAuth, updatePurchasedSubscription, updateOnboardingCompleted, updateBlueprintSubscription, logout } =
  authSlice.actions;
export default authSlice.reducer;
